import React, { Component } from 'react';

import { connect } from 'react-redux';
import Select from 'react-select';
import HelperFunctions from "utils/HelperFunctions";

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


/* date type enum */
const dateEnum = {
    thisWeek: 1,
    thisCalendarMonth: 2,
    thisCalendarYear: 3,
    last3Month: 4,
    last6Month: 5,
    last12Month: 6,
    last24Month: 7,
    allTime: 8,
    custom: 9
}

/*const datepickervalues = [
    { label: "Choose Dates ", value: dateEnum.custom },
    { label: "This Week ", value: dateEnum.thisWeek },
    { label: "This Calendar Month ", value: dateEnum.thisCalendarMonth },
    { label: "This Calendar Year ", value: dateEnum.thisCalendarYear },
    { label: "Last 3 months ", value: dateEnum.last3Month },
    { label: "Last 6 months ", value: dateEnum.last6Month },
    { label: "Last 12 months ", value: dateEnum.last12Month },
    { label: "Last 24 months ", value: dateEnum.last24Month },
    { label: "All Time ", value: dateEnum.allTime },
];*/

var filterType = dateEnum.allTime;
var selectedStartDates = null;
var selectedEndDates = null;

class DatePickerDropDown extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOption: null,
            datePickerVisible: false,
            selectedDates: null,
            startDate: new Date(),
            endDate: new Date(),
            startDateValue: "",
            endDateValue: ""
        }
        this.datepickervalues = [
            { label: "Choose Dates ", value: dateEnum.custom },
            { label: "This Week ", value: dateEnum.thisWeek },
            { label: "This Calendar Month ", value: dateEnum.thisCalendarMonth },
            { label: "This Calendar Year ", value: dateEnum.thisCalendarYear },
            { label: "Last 3 months ", value: dateEnum.last3Month },
            { label: "Last 6 months ", value: dateEnum.last6Month },
            { label: "Last 12 months ", value: dateEnum.last12Month },
            { label: "Last 24 months ", value: dateEnum.last24Month },
            { label: "All Time ", value: dateEnum.allTime },
        ];

        this.initilizeDropdown();
        this.closeDatePicker = this.closeDatePicker.bind(this);
    }

    async componentDidMount() {
        
        if(!this.state.selectedOption && this.props.area==="emailreports"){
            var obj = {
                value:dateEnum.last12Month
            };
            this.externalFilterChanged(obj);
        }
    }

    initilizeDropdown() {
        for (let index in this.datepickervalues) {

            if (index > 0 && index < (this.datepickervalues.length - 1)) {
                var currentday = new Date();
                currentday.setHours(0, 0, 0, 0);

                filterType = this.datepickervalues[index].value;
                let dateObject = this.findDate(filterType, currentday);

                this.datepickervalues[index].label = this.datepickervalues[index].label + "    ( " + dateObject.startDate.toLocaleDateString("en-US") + " - " + dateObject.endDate.toLocaleDateString("en-US") + " )";
            }
        }
    }

    findDate(filterType, currentday) {
        let dateObject = {};
        switch (filterType) {
            case dateEnum.thisWeek:
                dateObject.startDate = HelperFunctions.getMondayOfCurrentWeek(currentday);
                dateObject.endDate = HelperFunctions.getSundayOfCurrentWeek(currentday);
                return dateObject;
            case dateEnum.thisCalendarMonth:
                dateObject.startDate = HelperFunctions.getfirstDayOfCurrentMonth();
                dateObject.endDate = HelperFunctions.getlastDayOfCurrentMonth();
                return dateObject;
            case dateEnum.thisCalendarYear:
                dateObject.startDate = new Date("1/1/" + (new Date()).getFullYear());
                dateObject.endDate = new Date("12/31/" + (new Date()).getFullYear());
                return dateObject;
            case dateEnum.last3Month:
                dateObject.startDate = new Date(currentday.setMonth(currentday.getMonth() - 3));
                dateObject.endDate = new Date();
                return dateObject;
            case dateEnum.last6Month:
                dateObject.startDate = new Date(currentday.setMonth(currentday.getMonth() - 6));
                dateObject.endDate = new Date();
                return dateObject;
            case dateEnum.last12Month:
                dateObject.startDate = new Date(currentday.setMonth(currentday.getMonth() - 12));
                dateObject.endDate = new Date();
                return dateObject;
            case dateEnum.last24Month:
                dateObject.startDate = new Date(currentday.setMonth(currentday.getMonth() - 24));
                dateObject.endDate = new Date();
                return dateObject;
            case dateEnum.allTime: return this.props.onFilterChange(null, null, true);
            case dateEnum.custom:
                return this.props.onFilterChange(selectedStartDates, selectedEndDates, false);
            default: return true;
        }
    }

    dropdownChangeHandler = selectedOption => {
        if (selectedOption.value === dateEnum.custom) {
            let start = ("0" + (this.state.startDate.getMonth() + 1)).slice(-2) + '/' + ("0" + this.state.startDate.getDate()).slice(-2) + '/' + this.state.startDate.getFullYear();
            let end = ("0" + (this.state.endDate.getMonth() + 1)).slice(-2) + '/' + ("0" + this.state.endDate.getDate()).slice(-2) + '/' + this.state.endDate.getFullYear();

            this.setState({
                datePickerVisible: true,
                startDateValue: start,
                endDateValue: end
            });
            
            // Notify parent component that date picker is open
            if (this.props.onDatePickerToggle) {
                this.props.onDatePickerToggle(true);
            }
        } else {
            this.closeDatePicker();
            this.externalFilterChanged(selectedOption);
        }
    }

    externalFilterChanged(selectedOption) {
        filterType = selectedOption.value;
        var currentday = new Date();
        currentday.setHours(0, 0, 0, 0);

        switch (filterType) {
            case dateEnum.thisWeek:
                let firstDayofWeek = HelperFunctions.getMondayOfCurrentWeek(currentday);
                let lastDayofWeek = HelperFunctions.getSundayOfCurrentWeek(currentday);
                return this.props.onFilterChange(firstDayofWeek, lastDayofWeek, false);
            case dateEnum.thisCalendarMonth:
                let firstDateOfCurrentMonth = HelperFunctions.getfirstDayOfCurrentMonth();
                let lastDateOfCurrentMonth = HelperFunctions.getlastDayOfCurrentMonth();
                return this.props.onFilterChange(firstDateOfCurrentMonth, lastDateOfCurrentMonth, false);
            case dateEnum.thisCalendarYear:
                let firstDateCurrentYear = new Date("1/1/" + (new Date()).getFullYear());
                let lastDateCurrentYear = new Date("12/31/" + (new Date()).getFullYear());
                return this.props.onFilterChange(firstDateCurrentYear, lastDateCurrentYear, false);
            case dateEnum.last3Month:
                let last3Month = new Date(currentday.setMonth(currentday.getMonth() - 3));
                return this.props.onFilterChange(last3Month, new Date(), false);
            case dateEnum.last6Month:
                let last6Month = new Date(currentday.setMonth(currentday.getMonth() - 6));
                return this.props.onFilterChange(last6Month, new Date(), false);
            case dateEnum.last12Month:
                let last12Month = new Date(currentday.setMonth(currentday.getMonth() - 12));
                return this.props.onFilterChange(last12Month, new Date(), false);
            case dateEnum.last24Month:
                let last24Month = new Date(currentday.setMonth(currentday.getMonth() - 24));
                return this.props.onFilterChange(last24Month, new Date(), false);
            case dateEnum.allTime: return this.props.onFilterChange(null, null, true);
            case dateEnum.custom:
                return this.props.onFilterChange(selectedStartDates, selectedEndDates, false);
            default: return true;
        }
    }


    onStartDateChange = (event) => {
        var value = event.target.value;
        var parts = value.split("/");
        var startDate = new Date(Number(parts[2]), Number(parts[0]) - 1, Number(parts[1]));
        startDate.setHours(0, 0, 0, 0);       
        
        this.setState({startDateValue: value});

        if (startDate !== "Invalid Date") {
            this.setState({ startDate: startDate });
        }
    }

    onEndDateChange = (event) => {
        var value = event.target.value;
        var parts = value.split("/");
        var endDate = new Date(Number(parts[2]), Number(parts[0]) - 1, Number(parts[1]));
        endDate.setHours(0, 0, 0, 0);

        this.setState({endDateValue: value});

        if (endDate !== "Invalid Date") {
            this.setState({ endDate: endDate });
        }
    }

    _handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            this.setState({ datePickerVisible: false });

            // Notify parent component that date picker is closed
            if (this.props.onDatePickerToggle) {
                this.props.onDatePickerToggle(false);
            }

            selectedStartDates = this.state.startDate;
            selectedEndDates = this.state.endDate;

            this.datepickervalues[0].label = "Choose Dates    ( " + selectedStartDates.toLocaleDateString("en-US") + " - " + selectedEndDates.toLocaleDateString("en-US") + " )";

            this.externalFilterChanged(this.datepickervalues[0]);
        }
    }

    closeDatePicker() {
        this.setState({ datePickerVisible: false });
        
        // Notify parent component that date picker is closed
        if (this.props.onDatePickerToggle) {
            this.props.onDatePickerToggle(false);
        }
    }

    render() {
        return (
            <div className="d-flex flex-row-reverse position-relative">
                <Select
                    classNamePrefix="date-picker"
                    id="marketing-plays-date-picker"
                    defaultValue={this.datepickervalues[dateEnum.last12Month]}
                    options={this.datepickervalues}
                    value={this.selectedOption}
                    className="marketing-plays-date-picker"
                    onChange={this.dropdownChangeHandler}
                />

                {this.state.datePickerVisible && (
                    <div id="ddme-datepicker-div">
                        <div>
                            <i className="fa fa-times" onClick={this.closeDatePicker}></i>
                            <input type="text" value={this.state.startDateValue} placeholder="Start Date" onKeyDown={this._handleKeyDown} onChange={this.onStartDateChange} className="start_date" />
                            <span>to</span>
                            <input type="text" value={this.state.endDateValue} placeholder="End Date" onKeyDown={this._handleKeyDown} onChange={this.onEndDateChange} />
                        </div>
                        <DatePicker
                            selectsRange
                            inline
                            startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={(dates) => {
                                const [start, end] = dates;
                                this.setState({ startDate: start, endDate: end });
                                if (start && end) {
                                    selectedStartDates = start;
                                    selectedEndDates = end;

                                    let startStr = ("0" + (start.getMonth() + 1)).slice(-2) + '/' + ("0" + start.getDate()).slice(-2) + '/' + start.getFullYear();
                                    let endStr = ("0" + (end.getMonth() + 1)).slice(-2) + '/' + ("0" + end.getDate()).slice(-2) + '/' + end.getFullYear();
                                    this.setState({ startDateValue: startStr, endDateValue: endStr });

                                    this.datepickervalues[0].label = "Choose Dates    ( " + start.toLocaleDateString("en-US") + " - " + end.toLocaleDateString("en-US") + " )";

                                    this.externalFilterChanged(this.datepickervalues[0]);

                                    setTimeout(() => {
                                        this.setState({ datePickerVisible: false });
                                        if (this.props.onDatePickerToggle) {
                                            this.props.onDatePickerToggle(false);
                                        }
                                    }, 0);
                                }
                            }}
                        />
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { dataSourcesDataTable: state.dataSource.dataSourcesDataTable }
};

export default connect(mapStateToProps)(DatePickerDropDown);
